type PdfJs = typeof import('pdfjs-dist');

let pdfJsPromise: Promise<PdfJs> | null = null;

/**
 * Loads pdf.js only when a PDF is opened. pdf.js touches browser-only globals
 * (DOMMatrix) as soon as it is imported, so a top-level import would break every
 * module that pulls in the router, and it would add the whole library to the
 * first Study page load.
 */
export function loadPdfJs(): Promise<PdfJs> {
  pdfJsPromise ??= Promise.all([
    import('pdfjs-dist'),
    import('pdfjs-dist/build/pdf.worker.min.mjs?url'),
  ]).then(([pdfJs, worker]) => {
    pdfJs.GlobalWorkerOptions.workerSrc = worker.default;
    return pdfJs;
  });
  return pdfJsPromise;
}
